"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bidderHasCreative = void 0;
/**
 * extracted from utilities - loadHbAdPrebid line 1846
 * This is fine, its extracted prod functionality.
 */
function bidderHasCreative(bid) {
    var _a;
    return typeof ((_a = bid === null || bid === void 0 ? void 0 : bid.source_bid) === null || _a === void 0 ? void 0 : _a.adId) === "string";
}
exports.bidderHasCreative = bidderHasCreative;
exports.default = {
    bidderHasCreative: bidderHasCreative,
};
